import { render } from "./RandomNumberCard.vue?vue&type=template&id=3baf0de2&scoped=true"
import script from "./RandomNumberCard.vue?vue&type=script&lang=ts"
export * from "./RandomNumberCard.vue?vue&type=script&lang=ts"

import "./RandomNumberCard.vue?vue&type=style&index=0&id=3baf0de2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3baf0de2"

export default script